import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetBetLimits = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetBetLimitsRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetBetLimitsRequestData, TServerSendResponse>({
            ID: 35649,
            responses: [35650, 35651],
            description: 'Set bet limits',
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
